const routes = [
    {
        path: '/research',
        component: () => import('@/pages/research/ResearchHome.vue'),
        meta: { breadCrumb: 'Research Requests', entity: 'research' },
        children: [
            {
                path: '',
                name: 'research',
                component: () => import('@/pages/research/ResearchList.vue'),
                props: true,
                meta: { breadCrumb: 'All' },
            },
            {
                path: 'filter/:eventId?/:teamId?',
                name: 'filterResearch',
                component: () => import('@/pages/research/ResearchList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newResearch',
                component: () => import('@/pages/research/Editor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editResearch',
                component: () => import('@/pages/research/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readResearch',
                component: () => import('@/pages/research/ResearchRequestReader.vue'),
                props: true,
                meta: { breadCrumb: 'Read' },
            },
            {
                path: 'archive',
                name: 'researchArchive',
                component: () => import('@/pages/research/ResearchArchive.vue'),
                props: true,
                meta: { breadCrumb: 'All' },
            },
            {
                path: 'print',
                name: 'printResearch',
                component: () => import('@/pages/research/ResearchPrint.vue'),
                props: true,
                meta: { breadCrumb: 'Print' },
            },
        ],
    },
]

export default routes
